import React from "react";
import { cn } from "@/lib/utils";

export function CommandHero({ eyebrow, title, description, actions, visual, children, className, contentClassName, visualClassName, dark = false, testId = "command-hero" }) {
  return (
    <section
      className={cn(
        "relative overflow-hidden rounded-xl border bg-white p-5 shadow-[0_14px_44px_rgba(18, 22, 20,0.08)] ring-1 ring-white/70 md:p-6",
        dark && "bg-[#0C0F0E] text-white shadow-[0_24px_90px_-42px_rgba(18, 22, 20,0.95)] ring-slate-900/40",
        className,
      )}
      style={{
        borderColor: dark ? "rgba(150, 160, 152,0.24)" : "var(--border-subtle)",
        backgroundColor: dark ? "#0C0F0E" : undefined,
      }}
      data-testid={testId}
    >
      <div
        aria-hidden
        className={cn("pointer-events-none absolute inset-0 opacity-95", dark && "opacity-100")}
        style={{
          backgroundImage:
            dark
              ? "linear-gradient(125deg, rgba(12, 15, 14,0.98), rgba(18, 22, 20,0.94) 46%, rgba(11, 60, 40,0.92)), radial-gradient(640px 320px at 18% 0%, rgba(18, 147, 79,0.42), transparent 64%), radial-gradient(520px 260px at 88% 12%, rgba(20,184,166,0.18), transparent 64%)"
              : "radial-gradient(520px 260px at 6% -18%, rgba(18, 147, 79, 0.14), transparent 66%), radial-gradient(480px 240px at 96% 0%, rgba(143, 224, 74, 0.12), transparent 64%)",
        }}
      />
      {dark ? (
        <div aria-hidden className="pointer-events-none absolute inset-0 opacity-30 [background-image:linear-gradient(rgba(150, 160, 152,0.18)_1px,transparent_1px),linear-gradient(90deg,rgba(150, 160, 152,0.14)_1px,transparent_1px)] [background-size:42px_42px]" />
      ) : null}
      <div className="relative grid gap-5 lg:grid-cols-[minmax(0,1.25fr)_minmax(280px,0.75fr)] lg:items-center">
        <div className={cn("min-w-0", contentClassName)}>
          {eyebrow ? (
            <p className={cn("mb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500", dark && "text-[color:var(--text-2)]/80")}>{eyebrow}</p>
          ) : null}
          <h1 className={cn("max-w-3xl text-2xl font-bold leading-[1.12] tracking-[-0.035em] text-slate-950 sm:text-[34px]", dark && "text-white")}>
            {title}
          </h1>
          {description ? (
            <p className={cn("mt-3 max-w-2xl text-[15px] leading-[1.65] text-slate-600", dark && "text-slate-300")}>{description}</p>
          ) : null}
          {children ? <div className="mt-5">{children}</div> : null}
          {actions ? <div className="mt-5 flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
        {visual ? (
          <div
            className={cn(
              "rounded-lg border bg-white/82 p-4 shadow-[0_12px_30px_rgba(18, 22, 20,0.06)] backdrop-blur",
              dark && "border-white/10 bg-white/[0.06] shadow-[0_22px_60px_-34px_rgba(143, 224, 74,0.95)]",
              visualClassName,
            )}
            style={{ borderColor: dark ? "rgba(255,255,255,0.14)" : "var(--border-subtle)" }}
          >
            {visual}
          </div>
        ) : null}
      </div>
    </section>
  );
}
